import { ChangeEvent, useEffect, useState } from "react";
import HeaderComponent from "../../components/header";
import { useNavigate } from "react-router-dom";
import ContainerComponent from "../../components/conatiner";
import CardHeaderBackgroundComponent from "../../components/cardHeaderBackground";
import InputComponent from "../../components/input";
import TableComponent from "../../components/table";
import { IType } from "../../types";
import { DeleteTypeService, TypesService } from "../../services/types";
import { ToastErro, ToastSucesso } from "../../components/toast";
import ModalComponent from "../../components/modal";

const TypesPage = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(true);

    const [types, setTypes] = useState<any>([]);

    // variaveis de pesquisa
    const [description, setDescription] = useState<string>('');
    const [page, setPage] = useState<number>(1);
    // variaveis de pesquisa

    // funcao para pesquisar os tipos
    const getTypes = async () => {

        setLoading(true);

        await TypesService(description, page).then(resp => {
            setTypes(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // funcao para pesquisar os tipos

    // função para desativar/ativar tipo
    const disableType = async (id: number) => {

        (window as any).$("#disable" + id).modal("hide");

        setLoading(true);

        await DeleteTypeService(id).then(resp => {
            ToastSucesso(resp.data.message);
            getTypes();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
        })

    }
    // função para desativar/ativar tipo

    useEffect(() => {
        getTypes();
    }, [page]);

    return (
        <>
            <HeaderComponent
                title="Tipos"
                button="Tipo"
                iconButton="add"
                onClick={() => navigate('/types/create')}
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Pesquisar"
                    >
                        <div className="row">
                            <InputComponent
                                label="Descrição"
                                col={8}
                                defaultValue={description}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)}
                                size={"small"}
                            />
                            <div className="col-md-4">
                                <button className="btn btn-primary" type="button" onClick={() => page > 1 ? setPage(1) : getTypes()}>Pesquisar</button>
                                <button className="btn btn-danger" type="button" style={{ marginLeft: 15 }} onClick={() => (window as any).location.reload()}>Limpar</button>
                            </div>
                        </div>
                    </CardHeaderBackgroundComponent>

                    <TableComponent
                        title="Tipos"
                        columns={['ID', 'Descrição', 'Ativo', 'Ações']}
                        loading={loading}
                        last_page={types?.last_page}
                        onClickPagination={(e: ChangeEvent<unknown>, value: number) => setPage(value)}
                        page={page}
                    >
                        {
                            types?.data?.map((t: IType) => {
                                return (
                                    <tr key={t.id}>
                                        <td className="px-4">{t.id}</td>
                                        <td className="px-4">{t.description}</td>
                                        <td className="px-4">
                                            {
                                                t.active == 1

                                                    ?

                                                    <h5><span className="badge bg-success">Sim</span></h5>

                                                    :

                                                    <h5><span className="badge bg-danger">Não</span></h5>
                                            }
                                        </td>
                                        <td className="px-4">
                                            <button className="btn btn-text-danger" type="button" title={t.active == 1 ? "Desativar" : 'Ativar'} onClick={() => (window as any).$("#disable" + t.id).modal("show")}><i className="material-icons">{t.active == 1 ? 'delete' : 'upload'}</i></button>
                                            <ModalComponent
                                                title={t.active == 1 ? 'Desativar Tipo' : 'Ativar Tipo'}
                                                id={`disable${t.id}`}
                                            >
                                                <>
                                                    <p>Você tem certeza que deseja {t.active == 1 ? 'desativar' : 'ativar'} o tipo abaixo?</p>

                                                    <div className="row mt-4">
                                                        <div className="col-md-12">
                                                            <table className="table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>ID:</td>
                                                                        <td>{t.id}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Descrição:</td>
                                                                        <td>{t.description}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex justify-content-end mt-4">
                                                        <button className="btn btn-primary" type="button" onClick={() => disableType(t.id)}>{t.active == 1 ? 'Desativar' : 'Ativar'}</button>
                                                    </div>
                                                </>
                                            </ModalComponent>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </TableComponent>
                </>
            </ContainerComponent>
        </>
    );

}

export default TypesPage;